<div class="flex items-center gap-2">
  <mat-icon *ngIf="data.error" svgIcon="info" color="warn"></mat-icon>
  <mat-icon *ngIf="!data.error" svgIcon="check" color="primary"></mat-icon>
  <span [innerHTML]="data.message"></span>
</div>
